import { Box, IconEdit, IconLink } from '@n26/nxd'
import { useContext, useEffect, useState, type ReactNode } from 'react'
import { ConfigContext } from '@contexts/ConfigContext'
import { getContentfulUrl } from '@helpers/getContentfulUrl'

export const EditModule = ({
  children,
  moduleId,
  isSticky = false,
}: {
  children: ReactNode
  moduleId?: string
  isSticky?: boolean
}) => {
  const config = useContext(ConfigContext)

  const [topPosition, setTop] = useState('top-[60px] lg:top-[70px]')

  // if the banner is present, we need to adjust the top position
  useEffect(() => {
    if (document.getElementById('landing-page-banner')) {
      setTop('top-[92px] lg:top-[102px]')
    }
  }, [])

  if (!config?.showEditModuleLink || !moduleId) {
    return <>{children}</>
  }

  return (
    <Box
      position={isSticky ? 'sticky' : 'relative'}
      zIndex={isSticky ? 'sticky' : undefined}
      className={isSticky ? topPosition : undefined}
    >
      <Box position='absolute' top='0' right='0' className='z-header'>
        <IconLink
          aria-label='Edit Module'
          color='neutral'
          href={getContentfulUrl(moduleId, config?.contentfulEnvironment)}
          target='_blank'
          icon={<IconEdit />}
          variant='tertiary'
        />
      </Box>
      {children}
    </Box>
  )
}
